import { CHANNELS } from "../shared/channels";
import { NoteEntry } from "../shared/types";
import { call } from "./bridge";
import { sendChat } from "./chat_box";
import { byId, flashToast } from "./dom";
import { dictationSupported, wireDictateButton } from "./dictation";
import { canUse } from "./me";
import { showView } from "./navigation";
import { t } from "./i18n";

// the voice module on home: talk, check the words, then send them to the inbox, a new note or chi

export function setupVoiceModule(onNotes: () => void): void {
  const text = byId<HTMLTextAreaElement>("voice-text");
  const status = byId("voice-status");
  const mic = byId<HTMLButtonElement>("voice-mic");
  const actions = byId("voice-actions");
  wireDictateButton(mic, text, (live) => {
    status.textContent = live ? `${live}…` : "";
  });
  if (!dictationSupported()) status.textContent = t("this browser can't listen, type here instead");

  const paint = () => {
    actions.hidden = !text.value.trim();
    byId<HTMLButtonElement>("voice-inbox").hidden = !canUse("notes");
    byId<HTMLButtonElement>("voice-note").hidden = !canUse("notes");
    byId<HTMLButtonElement>("voice-ask").hidden = !canUse("chi");
  };
  text.addEventListener("input", paint);
  paint();

  const done = (message: string) => {
    flashToast(message);
    text.value = "";
    status.textContent = "";
    paint();
  };
  byId("voice-inbox").addEventListener("click", async () => {
    await call(CHANNELS.notesAppendInbox, text.value);
    done(t("added to your inbox"));
    onNotes();
  });
  byId("voice-note").addEventListener("click", async () => {
    const first = text.value.trim().split(/\n|(?<=[.!?。])\s/)[0].slice(0, 40);
    const saved = await call<NoteEntry>(CHANNELS.notesSave, first || t("untitled"), text.value);
    done(t("saved as {name}", { name: saved.name }));
    onNotes();
  });
  byId("voice-ask").addEventListener("click", () => {
    void sendChat(text.value);
    done(t("sent to chi"));
    showView("chat");
  });
  byId("voice-copy").addEventListener("click", () => {
    void navigator.clipboard?.writeText(text.value).then(() => flashToast(t("copied")), () => undefined);
  });
  byId("voice-clear").addEventListener("click", () => {
    text.value = "";
    paint();
  });
}
